import React from "react";
import { NotesContainer } from "./NotesStyle";
import UnderConstructionGIF from "../../images/construction.gif";

const Notes = () => {
  return (
    <NotesContainer>
      <h1>This page is under construction, please come back later!</h1>
      <img src={UnderConstructionGIF} />
    </NotesContainer>
  );
};

export default Notes;
